import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { HomeService } from '../../../../services/home.service';
import { TranslateService } from '../../../../services/translate.service';
import { Observable } from 'rxjs/internal/Observable';
import { EmployeesService } from '../../../../services/employees';
import { FinancialManagerService } from '../../../../services/financial-manager';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss'
})
export class EmployeeComponent {
  userData!: users;
  data!: any;
  id!: any;
  name!: any;
  job_title!: any;
  salary!: any;
  contentReady: boolean = true;
  uniqueDates: string[] = [];
  filteredDate: string = '';
  allRecords: any[] = [];
  bonuses: any[] = [];
  loans: any[] = [];
  deductions: any[] = [];
  filteredRecords: any;
  filteredMonth: any;
  originalBonuses: any[] = [];
  originalLoans: any[] = [];
  originalDeductions: any[] = [];
  uniqueMonths: string[] = [];
  showFinPopUp: boolean = false;
  amount!: any;
  note!: any;
  finId!: any;
  currentMonth!: any;
  userId!: any;
  isAr: boolean = localStorage.getItem("language") == "ar";
  constructor(private _router: Router,
    private _userService: UserService,
    private _FinancialManager: FinancialManagerService,
    private _employessService: EmployeesService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    this.currentMonth = `${year}-${month}`;
    this._userService.getUserId().subscribe({
      next: (data) => {

        this.userId = data['user_id'];

      },
      error: (error) => console.error(error),
    });
    this.route.queryParams.subscribe(params => {
      this.data = params;
      this.id = this.data["id"];
      this.name = this.data["name"];
      this.job_title = this.data["job_title"];
      this.salary = this.data["salary"];

      this.contentReady = false;
    });
    this.getOneEmployee()
  }
  getOneEmployee() {

    this.contentReady = true;
    const today = new Date();
    const todayString = today.toISOString().substring(0, 10); // e.g. "2025-06-09"
    const currentMonth = today.toISOString().substring(0, 7); // e.g. "2025-06"
    this._employessService.getOneEmployees(this.id).subscribe({
      next: (data) => {
        this.contentReady = false;

        // Store original data
        this.originalBonuses = data["bonuses"];
        this.originalLoans = data["loans"];
        this.originalDeductions = data["deductions"];

        // Combine to get all records
        this.allRecords = [
          ...this.originalBonuses,
          ...this.originalLoans,
          ...this.originalDeductions,
        ];

        // Extract and sort unique dates
        const dateSet = new Set(
          this.allRecords.map((rec) => rec.created_at.substring(0, 10))
        );
        this.uniqueDates = Array.from(dateSet).sort((a, b) => b.localeCompare(a));

        // Extract and sort unique months
        const monthSet = new Set(
          this.allRecords.map((rec) => rec.created_at.substring(0, 7))
        );
        this.uniqueMonths = Array.from(monthSet).sort((a, b) => b.localeCompare(a));
        // Set default filteredDate to today if available, else latest
        this.filteredDate = this.uniqueDates.includes(todayString)
          ? todayString
          : this.uniqueDates[0] ?? '';

        // Set default filteredMonth to current month if available, else latest
        this.filteredMonth = this.uniqueMonths.includes(currentMonth)
          ? currentMonth
          : this.uniqueMonths[0] ?? '';

        // Initial filtering
        if (this.filteredDate) this.filterByDate();
        if (this.filteredMonth) this.filterByMonth();
      },
      error: (error) => console.error(error),
    });
  }
  filterByDate() {
    this.filteredMonth = ''; // Clear month filter
    this.loans = this.originalLoans.filter((l) =>
      l.created_at.startsWith(this.filteredDate)
    );
    this.bonuses = this.originalBonuses.filter((b) =>
      b.created_at.startsWith(this.filteredDate)
    );
    this.deductions = this.originalDeductions.filter((d) =>
      d.created_at.startsWith(this.filteredDate)
    );
  }
  paySalary() {
    // 1. Filter financial records by currentMonth
    const currentBonuses = this.originalBonuses.filter(b =>
      b.created_at.toString().startsWith(this.currentMonth)
    );
    const currentLoans = this.originalLoans.filter(l =>
      l.created_at.toString().startsWith(this.currentMonth)
    );
    const currentDeductions = this.originalDeductions.filter(d =>
      d.created_at.toString().startsWith(this.currentMonth)
    );
    console.log("this.currentMonth =", this.currentMonth);
    console.log("Bonuses created_at =", this.originalBonuses.map(b => b.created_at));
    // 2. Calculate totals
    const totalBonuses = currentBonuses.reduce((sum, b) => sum + parseFloat(b.amount?.toString().replace(/[^0-9.-]+/g, '') || '0'), 0);
    const totalLoans = currentLoans.reduce((sum, l) => sum + parseFloat(l.amount?.toString().replace(/[^0-9.-]+/g, '') || '0'), 0);
    const totalDeductions = currentDeductions.reduce((sum, d) => sum + parseFloat(d.amount?.toString().replace(/[^0-9.-]+/g, '') || '0'), 0);

    // 3. Calculate net salary
    const baseSalary = parseFloat(this.salary);
    const netSalary = baseSalary + totalBonuses - totalLoans - totalDeductions;

    // 4. Confirm and proceed
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      html: this.isAr
        ? `الراتب الأساسي: ${baseSalary}<br>البونص: ${totalBonuses}<br>السلف: ${totalLoans}<br>الخصومات: ${totalDeductions}<br><b>الصافي: ${netSalary}</b>`
        : `Base Salary: ${baseSalary}<br>Bonuses: ${totalBonuses}<br>Loans: ${totalLoans}<br>Deductions: ${totalDeductions}<br><b>Net: ${netSalary}</b>`,
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "NO"
    }).then((result) => {
      if (result.isConfirmed) {
        this.addEx(this.name, netSalary, this.currentMonth);
      }
    });
  }
  filterByMonth() {
    this.filteredDate = ''; // Clear date filter
    this.loans = this.originalLoans.filter((l) =>
      l.created_at.startsWith(this.filteredMonth)
    );
    this.bonuses = this.originalBonuses.filter((b) =>
      b.created_at.startsWith(this.filteredMonth)
    );
    this.deductions = this.originalDeductions.filter((d) =>
      d.created_at.startsWith(this.filteredMonth)
    );
  }
  addLoan() {
    this.showFinPopUp = true;
    this.finId = 1;
  }
  addDeduction() {
    this.showFinPopUp = true;
    this.finId = 2;
  }
  addBonuses() {
    this.showFinPopUp = true;
    this.finId = 3;
  }
  close() {
    this.finId = null
    this.showFinPopUp = false;
  }
  addEx(employeeName: any, total: any, month: any) {
    
    if (month) {
      var bonusPayload = {
        employee_id: this.userId,
        username: localStorage.getItem("username"),
        amount: total,
        note: employeeName + " - " + month,
        type: "1"
      };

    }
    else {
      var bonusPayload = {
        employee_id: this.userId,
        username: localStorage.getItem("username"),
        amount: total,
        note:  employeeName + " - ",
        type: "2"
      };
    }

    this._FinancialManager.addexpenses(bonusPayload).subscribe({
      next: (data) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تمام" : 'success',
          text: this.isAr ? " المرتب اضاف للمصروفات" : 'Salary payed',
        });
      },
      error: (error) => console.error(error),
    });
  }
  onSubmit() {
    this.contentReady = true;
    const bonusPayload = {
      amount: this.amount,
      note: this.note
    };
    if (this.finId == 1) {
      this._employessService.addLoan(this.id, bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getOneEmployee()
          this.close()
          this.addEx(this.name, this.amount, null);
        },
        error: (error) => console.error(error),
      });

    }
    else if (this.finId == 2) {
      this._employessService.addDeduction(this.id, bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getOneEmployee()
          this.close()
        },
        error: (error) => console.error(error),
      });

    }
    else {


      this._employessService.addBonus(this.id, bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getOneEmployee()
          this.close()

        },
        error: (error) => console.error(error),
      });

    }
  }
}
